import { ArrowDropDown } from '@mui/icons-material';
import { Tab, TabProps, Theme } from '@mui/material';
import { forwardRef } from 'react';
import { ActionMenu } from '../../common/components/ActionMenu';
import { Route } from '../../routing/routes';
import { HIDDEN_TAB_STYLES } from '../common/tab-styles';

export type ActionMenuTabProps = TabProps<'a'> & {
  tabs: Route[];
  activeTab: Route;
  theme: Theme;
};

export const ActionMenuTab = forwardRef<HTMLAnchorElement, ActionMenuTabProps>(({ tabs = [], activeTab, theme, label, ...tabProps }, ref) => {
  return (
    <ActionMenu
      uppercase
      actions={tabs.map((tab) => ({
        label: tab.name || '',
        link: { href: tab.path },
        isSelected: activeTab?.path === tab.path,
      }))}
      AnchorComponent={(anchorProps) => {
        return (
          <Tab
            ref={ref}
            {...tabProps}
            {...anchorProps}
            // Empty href is necessary to coerce the prop types of Tab to a link and avoid TypeScript errors
            // To revisit in case of @mui/material updates
            href=""
            sx={{ ...HIDDEN_TAB_STYLES, pr: 1 }}
            label={label}
            icon={<ArrowDropDown />}
            iconPosition="end"
          />
        );
      }}
      theme={theme}
    />
  );
});
